import React from 'react';

class Clipboard extends React.Component {
  static propTypes = {
  };

  static defaultProps = {
  };

  $input = React.createRef()

  state = {
    text: 'copy',
  };

  render = () => {
    return (
      <div className='Clipboard'>
        <input
          ref={this.$input}
          type='text'
          defaultValue={this.props.value}
        />

        <a
          className='Badge Badge--copy'
          onClick={() => {
            this.$input.current.select()

            if (document.execCommand('copy')) {
              this.$input.current.blur()

              this.setState({
                text: 'copied!',
              }, () => {
                window.setTimeout(() => {
                  this.setState({
                    text: 'copy',
                  })
                }, 1000)
              })
            }
          }}
        >
          {this.state.text}
        </a>
      </div>
    );
  }
}

export default Clipboard;
